import React from 'react';

import {Layout, Text} from '@phonectas/unifon-ui-kit';
import {serviceStatusesColor} from 'utils/div';
import StatusOk from '../icons/StatusOk';
import StatusDot from '../icons/StatusDot';
import CircleXIcon from '../icons/CircleXIcon';
import CircleArrowRigthIcon from '../icons/CircleArrowRigthIcon';
import CircleIcon from '../icons/CircleIcon';
import CircleArrowLeftIcon from '../icons/CircleArrowLeftIcon';

interface TemplateStatusColorProps {
    statusCode: string;
    compact?: boolean;
}


const TemplateStatusColor: React.FC<TemplateStatusColorProps> = ({statusCode, compact = false}) => {
	const {text, priColor = '', secColor = '', icon} = serviceStatusesColor(statusCode);
	let iconComponent: React.ReactNode = null;
	let textColor: string | null = null;

	switch (icon) {
	case 'active':
		iconComponent = <StatusOk priColor={priColor} secColor={secColor}/>;
		textColor = priColor;
		break;
	case 'sperret':
		iconComponent = <CircleXIcon color={priColor}/>;
		textColor = priColor;
		break;
	case 'underInportering':
		iconComponent = <CircleArrowRigthIcon color={priColor}/>;
		textColor = secColor;
		break;
	case 'reservert':
		iconComponent = <CircleIcon color={priColor}/>;
		textColor = secColor;
		break;
	case 'underUtportering':
		iconComponent = <CircleArrowLeftIcon color={priColor}/>;
		textColor = secColor;
		break;
	case 'utPortert':
		iconComponent = <CircleIcon color={priColor}/>;
		textColor = secColor;
		break;
	default:
		iconComponent = <CircleIcon color={priColor}/>;
		textColor = secColor;
		break;
	}

	return (
		<Layout alignItems="center" gap="sm">
			{!compact ? iconComponent : <StatusDot color={priColor} />}
			<Text variant="body1" style={{color: textColor}}>{text}</Text>
		</Layout>
	);
}

export default TemplateStatusColor;
